import { faArrowsTurnToDots, faComment, faFlask, faMagnifyingGlass, faMessage, faNoteSticky, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { use, useContext, useEffect, useMemo, useState } from 'react';
import { Accordion, Spinner } from 'react-bootstrap';

import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';
import { QualityColumnType } from '../../../Types/LotDetailQuality';
import { Section } from '../../../Types/Section';
import BatchesSection from '../LotDetailsComponents/BatchesSection';
import CommentsSection from '../LotDetailsComponents/CommentsSection';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import LabResultsSection, { LabResultsColumnType } from '../LotDetailsComponents/LabResultsSection';
import QualitiesSection from '../LotDetailsComponents/QualitiesSection';
import LotDetailSummary from '../LotDetailsComponents/Summary';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import { LotDetailSection } from '../LotDetailSection';
import { SectionNavigation } from '../SectionNavigation';

function LotDetails_SCP_CAT() {
    const { lotDetail } = useContext(LotDetailContext);
    const { userPreferences, loading: userPreferencesLoading, setActiveSections } = use(UserPreferencesContext);
    const [loading, setLoading] = useState(false);

    const qualityColumns: QualityColumnType[] = useMemo(() => [
        "Name",
        "LBMLab",
        "Min",
        "Target",
        "Max",
        "Units",
        "displayOrder",
    ], []);

    const labResultColumns: LabResultsColumnType[] = [
        "SampleTime",
        "Lot",
        "Quality",
        "Analysis",
        "Component",
        "SamplingPoint",
        "SMSampleId",
        "Value",
        "Units"
    ];

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'batches', title: 'LotDetails.Batches.Title', icon: faArrowsTurnToDots, component: <BatchesSection showClassifications={false} /> },
        { name: 'qualities', title: 'LotDetails.Qualities.Title', icon: faMagnifyingGlass, component: <QualitiesSection customQualityColumns={qualityColumns} showGraph={false} /> },
        { name: 'labresults', title: 'LotDetails.LabResults.Title', titleSuffix: `${lotDetail.labResults.length}`, icon: faFlask, component: <LabResultsSection customColumns={labResultColumns} /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
        { name: 'comments', title: 'LotDetails.Comments.Title', icon: faMessage, component: <CommentsSection /> },
    ];

    const [defaultActiveSections, setDefaultActiveSections] = useState(sections.map(section => section.name));
    useEffect(() => {
        if (userPreferences?.lotDetail?.activeSections) {
            setDefaultActiveSections(userPreferences?.lotDetail?.activeSections);
        }
    }, [userPreferences?.lotDetail?.activeSections]);

    if (userPreferencesLoading) {
        return (
            <div className="d-flex justify-content-center mb-3">
                <Spinner animation="border" />
            </div>
        );
    }

    return (lotDetail &&
        <>
            <LotDetailSummary setLoading={setLoading} />

            <SectionNavigation sections={sections} />

            <Accordion activeKey={defaultActiveSections} onSelect={(eventKey) => setActiveSections(eventKey as string[])} alwaysOpen className="mb-2">
                {sections.map(section =>
                    <LotDetailSection
                        key={section.name}
                        name={section.name}
                        icon={section.icon}
                        title={section.title}
                        titleSuffix={section.titleSuffix}
                        component={section.component} />)
                }
            </Accordion>
        </>
    );
}

export default LotDetails_SCP_CAT;